import {useMutation, useQueryClient} from "@tanstack/react-query";

import {errorHandler} from "@/src/modules/core/lib";

import {shiftsService} from "../services";
import type {CheckPatrolVisitRequest} from "../types";

export function useCheckPatrolVisit() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      shiftId,
      visitId,
      data,
    }: {
      shiftId: number;
      visitId: number;
      data: CheckPatrolVisitRequest;
    }) => shiftsService.checkPatrolVisit(shiftId, visitId, data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ["active-shift"]});
    },
    onError: errorHandler,
  });
}
